import api from './api';
import type { Expense, Paginated } from '../types/api';

export async function listExpenses() {
  const { data } = await api.get<Paginated<Expense> | Expense[]>('/finance/expenses/');
  return Array.isArray(data) ? data : data.results;
}

export async function createExpense(payload: Partial<Expense>) {
  const { data } = await api.post<Expense>('/finance/expenses/', payload);
  return data;
}

export async function updateExpense(id: number, payload: Partial<Expense>) {
  const { data } = await api.patch<Expense>(`/finance/expenses/${id}/`, payload);
  return data;
}

export async function deleteExpense(id: number) {
  await api.delete(`/finance/expenses/${id}/`);
}
